// frontend/src/components/EducatorRoutes.js
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Placeholder components - replace with actual educator pages
const EducatorDashboard = () => (
  <div style={{ padding: '20px' }}>
    <h1>Educator Dashboard</h1>
    <p>Welcome to the educator dashboard. This is where you can manage questions and content.</p>
  </div>
);

const CreateQuestion = () => (
  <div style={{ padding: '20px' }}>
    <h1>Create Question</h1>
    <p>Create new questions for students.</p>
  </div>
);

const ManageContent = () => (
  <div style={{ padding: '20px' }}>
    <h1>Manage Content</h1>
    <p>Manage your educational content.</p>
  </div>
);

const EducatorRoutes = () => {
  const { user } = useAuth();

  // Only allow educators to access these routes
  if (user?.role !== 'educator') {
    return <Navigate to="/home" replace />;
  }

  return (
    <Routes>
      <Route path="dashboard" element={<EducatorDashboard />} />
      <Route path="create-question" element={<CreateQuestion />} />
      <Route path="manage-content" element={<ManageContent />} />
      <Route path="*" element={<Navigate to="/educator/dashboard" replace />} />
    </Routes>
  );
};

export default EducatorRoutes;